<template>
  <PublicPage title="Des offres adaptées à votre activité" crumb="Tarif"
              lead="Choisissez la formule qui correspond à vos besoins et évoluez à votre rythme. Toutes les offres incluent l’hébergement sécurisé, les mises à jour et un support réactif.">
    <div class="pricing-container">

      <!-- START -->
      <section class="pricing-card" aria-labelledby="offer-starter">
        <div>
          <p class="badge">Pour démarrer</p>

          <h2 id="offer-starter">Starter</h2>

          <p class="price">9€ <span>/ mois</span></p>

          <p class="description">
            Idéal pour les indépendants et les petites activités qui souhaitent gérer
            leurs devis et factures simplement.
          </p>

          <ul>
            <li>Prospection commerciale</li>
            <li>Suivi des clients</li>
            <li>Gestion des devis et factures</li>
            <li>Facturation électronique</li>
          </ul>
        </div>

        <router-link to="/register" class="pub-btn pub-btn--ghost">Choisir cette offre</router-link>
      </section>

      <!-- STANDARD -->
      <section class="pricing-card featured" aria-labelledby="offer-standard">
        <div>
          <p class="badge featured-badge">Le plus populaire</p>

          <h2 id="offer-standard">Standard</h2>

          <p class="price">19€ <span>/ mois</span></p>

          <p class="description">
            Pour les entreprises qui souhaitent automatiser leur gestion
            commerciale et gagner du temps au quotidien.
          </p>

          <ul>
            <li>Tout le pack Starter</li>
            <li>Multi-utilisateurs</li>
            <li>Export comptable</li>
            <li>Signature électronique</li>
            <li>Gestion des impayés</li>
            <li>Logo et couleur personnalisable</li>
          </ul>
        </div>

        <router-link to="/register" class="pub-btn pub-btn--primary">Choisir cette offre</router-link>
      </section>

      <!-- ULTIMATE -->
      <section class="pricing-card" aria-labelledby="offer-complete">
        <div>
          <p class="badge">Le plus complet</p>

          <h2 id="offer-complete">Complet</h2>

          <p class="price">39€ <span>/ mois</span></p>

          <p class="description">
            La solution complète pour centraliser la gestion de votre entreprise
            dans un seul outil.
          </p>

          <ul>
            <li>Tout le pack Standard</li>
            <li>Relances automatiques des impayés</li>
            <li>Intéropérabilité comptable</li>
            <li>Statistiques et reporting</li>
          </ul>
        </div>

        <router-link to="/register" class="pub-btn pub-btn--ghost">Choisir cette offre</router-link>
      </section>

    </div>
  </PublicPage>
</template>

<script>
import { useHead } from "@vueuse/head";
import PublicPage from "@/components/public/PublicPage.vue";

export default {
  name: 'PricingView',
  components: {PublicPage},
  mounted() {
    useHead({
      title: 'Tarifs - Logiciel de facturation électronique | Citron Digital',
      meta: [
        {
          name: 'description',
          content: 'Découvrez les différentes offres de Citron Digital : facturation électronique, gestion client, prospection et comptabilité.'
        }
      ]
    });
  }
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/public.styl';

.pricing-container
  display grid
  gap 36px
  align-items stretch

// Une « feuille » par offre
.pricing-card
  position relative
  display flex
  flex-direction column
  justify-content space-between
  gap 24px
  box-sizing border-box
  padding 28px 26px 26px
  background PUB_WHITE
  border 1px solid PUB_RULE
  border-top 4px solid PUB_RULE
  border-radius 4px
  h2
    margin 14px 0 0
    color PUB_INK
    font-family PUB_FONT_DISPLAY
    font-weight 400
    font-size 1.9rem
    line-height 1.15
  ul
    margin 22px 0 0
    padding 0
    list-style none
  li
    position relative
    margin 0 0 10px
    padding 0 0 0 28px
    color PUB_INK
    font-family PUB_FONT_TEXT
    font-size 1rem
    line-height 1.45
    &::before
      content ''
      position absolute
      left 5px
      top 0.2em
      width 0.45em
      height 0.85em
      border-right 3px solid PUB_LEAF
      border-bottom 3px solid PUB_LEAF
      transform rotate(40deg)
  .pub-btn
    width 100%

// L'offre mise en avant : le liseré citron des onglets du site
.featured
  border-top-color PUB_LEMON

.badge
  display inline-block
  margin 0
  padding 2px 10px
  background PUB_PAPER
  border 1px solid PUB_RULE
  border-radius 3px
  color PUB_INK_SOFT
  font-family PUB_FONT_TEXT
  font-size 0.85rem
  font-weight 650
  line-height 1.5

.featured-badge
  background PUB_LEMON
  border-color PUB_INK
  color PUB_INK

.price
  margin 8px 0 0
  color PUB_INK
  font-family PUB_FONT_DISPLAY
  font-size 2.6rem
  line-height 1.1
  span
    color PUB_MUTED
    font-family PUB_FONT_TEXT
    font-size 1rem

.description
  margin 14px 0 0
  color PUB_INK_SOFT
  font-family PUB_FONT_TEXT
  font-size 1rem
  line-height 1.6

@media (min-width: 1000px)
  .pricing-container
    grid-template-columns repeat(3, 1fr)
    gap 28px
  .featured
    margin-top -12px
    margin-bottom -12px
</style>
